module.exports = __webpack_public_path__ + "img/bag-sale.4a89a8b5.svg";